import {
  SET_USER_RESEARCH_LIST,
  SET_USER_RESEARCH_LIST_PAGE_NUM,
  SET_USER_RESEARCH_LIST_PAGE_TOTAL,
  SET_USER_RESEARCH_LIST_PAGE_SIZE,
  SET_USER_RESEARCH_LIST_SEARCHING,
  SET_USER_RESEARCH_LIST_LOADING,
  SET_PROJECT_LIST,
  SET_PROJECT_LIST_PAGE_NUM,
  SET_PROJECT_LIST_PAGE_SIZE,
  SET_PROJECT_LIST_PAGE_TOTAL,
  SET_VIEW_DATA_LIST,
  SET_VIEW_DATA_LIST_QUERY,
  SET_VIEW_DATA_LIST_SEARCHING,
  SET_VIEW_DATA_LIST_PAGE_TOTAL,
  SET_VIEW_DATA_LIST_PAGE_NUM,
  SET_VIEW_DATA_LIST_PAGE_SIZE,
  SET_QUETSIONNAIREID_NAME_LIST,
} from './mutation-types'
import api from '@/api'
import _ from 'lodash'
import { checkUserName } from '@/views/User/utils'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
})

const projectInitQuery = () => ({
  pageSize: 50,
  pageNum: 1,
})

const viewDataInitQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  projectId: '',
  userId: '',
  userName: '',
  businessType: '',
})

const state = {
  loading: false,
  searching: false,
  initQuery: initQuery(),
  receiveDetailSearching: false,
  initReceiveDetailQuery: viewDataInitQuery(),
  userResearchList: {
    list: [],
    listPageTotal: 0,
    query: initQuery(),
  },
  project: {
    list: [],
    listPageTotal: 0,
    query: projectInitQuery(),
    chooseQuestionnaireList: [],
  },
  viewData: {
    list: [],
    listPageTotal: 0,
    query: viewDataInitQuery(),
  },
}

const mutations = {
  [SET_USER_RESEARCH_LIST] (state, payload) {
    state.userResearchList.list = payload
  },
  [SET_USER_RESEARCH_LIST_PAGE_NUM] (state, payload) {
    state.userResearchList.query.pageNum = payload
  },
  [SET_USER_RESEARCH_LIST_PAGE_TOTAL] (state, payload) {
    state.userResearchList.listPageTotal = payload
  },
  [SET_USER_RESEARCH_LIST_PAGE_SIZE] (state, payload) {
    state.userResearchList.query.pageSize = payload
  },
  [SET_USER_RESEARCH_LIST_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_USER_RESEARCH_LIST_LOADING] (state, payload) {
    state.loading = payload
  },
  [SET_PROJECT_LIST] (state, payload) {
    state.project.list = payload
  },
  [SET_PROJECT_LIST_PAGE_NUM] (state, payload) {
    state.project.query.pageNum = payload
  },
  [SET_PROJECT_LIST_PAGE_SIZE] (state, payload) {
    state.project.query.pageSize = payload
  },
  [SET_PROJECT_LIST_PAGE_TOTAL] (state, payload) {
    state.project.listPageTotal = payload
  },
  [SET_VIEW_DATA_LIST] (state, payload) {
    state.viewData.list = payload
  },
  [SET_VIEW_DATA_LIST_QUERY] (state, payload) {
    state.viewData.query = {
      ...state.viewData.query,
      ...payload,
    }
  },
  [SET_VIEW_DATA_LIST_SEARCHING] (state, payload) {
    state.receiveDetailSearching = payload
  },
  [SET_VIEW_DATA_LIST_PAGE_TOTAL] (state, payload) {
    state.viewData.listPageTotal = payload
  },
  [SET_VIEW_DATA_LIST_PAGE_NUM] (state, payload) {
    state.viewData.query.pageNum = payload
  },
  [SET_VIEW_DATA_LIST_PAGE_SIZE] (state, payload) {
    state.viewData.query.pageSize = payload
  },
  [SET_QUETSIONNAIREID_NAME_LIST] (state, payload) {
    state.project.chooseQuestionnaireList = payload
  },
}

const actions = {
  async setUserResearchList ({commit, state}) {
    try {
      let query = {}
      _.forIn(state.userResearchList.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      let params = {
        ...query,
        pageNum: state.userResearchList.query.pageNum,
        pageSize: state.userResearchList.query.pageSize,
      }
      commit(SET_USER_RESEARCH_LIST_LOADING, true)
      const {data: {items, total}} = await api.feedbackApi.queryQuestionnaire(params)
      commit(SET_USER_RESEARCH_LIST_LOADING, false)
      commit(SET_USER_RESEARCH_LIST_SEARCHING, false)
      commit(SET_USER_RESEARCH_LIST, items)
      commit(SET_USER_RESEARCH_LIST_PAGE_TOTAL, total)
    } catch (error) {
      commit(SET_USER_RESEARCH_LIST_LOADING, false)
      commit(SET_USER_RESEARCH_LIST_SEARCHING, false)
      commit(SET_USER_RESEARCH_LIST, [])
      commit(SET_USER_RESEARCH_LIST_PAGE_TOTAL, 0)
    }
  },
  initUserResearchList ({dispatch}) {
    dispatch('setUserResearchList')
  },
  async changeUserResearchListPage ({commit, dispatch}, payload) {
    commit(SET_USER_RESEARCH_LIST_PAGE_NUM, payload.currentPage)
    if (payload.refresh) dispatch('setUserResearchList')
  },
  changeUserResearchListPageSize ({commit, dispatch}, payload) {
    commit(SET_USER_RESEARCH_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeUserResearchListPage', {currentPage: 1, refresh: true})
  },
  async addQuestionnaire ({dispatch}, payload) {
    const {code} = await api.feedbackApi.addQuestionnaire(payload)
    return code
  },
  async updateQuestionnaire ({dispatch}, payload) {
    const {code} = await api.feedbackApi.updateQuestionnaire(payload)
    return code
  },
  async deleteQuestionnaire ({dispatch}, payload) {
    const {data, code} = await api.feedbackApi.deleteQuestionnaire(payload)
    return {data, code}
  },

  async getProjectList ({commit}, payload) {
    try {
      let query = {}
      _.forIn(state.project.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      const {data: {items, total}} = await api.feedbackApi.queryProject(query)
      commit(SET_PROJECT_LIST, items)
      commit(SET_PROJECT_LIST_PAGE_TOTAL, total)
    } catch (error) {
      commit(SET_PROJECT_LIST, [])
      commit(SET_PROJECT_LIST_PAGE_TOTAL, 0)
    }
  },
  initProjectList ({dispatch}, payload) {
    dispatch('getProjectList')
  },
  async changeProjectListPage ({commit, dispatch}, payload) {
    commit(SET_PROJECT_LIST_PAGE_NUM, payload.currentPage)
    if (payload.refresh) dispatch('getProjectList')
  },
  changeProjectListPageSize ({commit, dispatch}, payload) {
    commit(SET_PROJECT_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeProjectListPage', {currentPage: 1, refresh: true})
  },
  async addProject ({dispatch}, payload) {
    const {code} = await api.feedbackApi.addProject(payload)
    return code
  },
  async updateProject ({dispatch}, payload) {
    const {code} = await api.feedbackApi.updateProject(payload)
    return code
  },
  async deleteProject ({dispatch}, payload) {
    const {code} = await api.feedbackApi.deleteProject(payload)
    return code
  },
  async recycleProject ({dispatch}, payload) {
    const {code} = await api.feedbackApi.recycleProject(payload)
    return code
  },
  async uploadUserExcel ({dispatch}, payload) {
    const data = await api.feedbackApi.uploadUserExcel(payload)
    return data
  },
  async setViewDataList ({commit, state, dispatch}, payload) {
    try {
      let query = {}
      _.forIn(state.viewData.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      let params = {
        ...query,
        pageNum: state.viewData.query.pageNum,
        pageSize: state.viewData.query.pageSize,
        ...payload,
      }
      if (payload && !payload.userName && params.userName) {
        delete params.userName
      }
      const {data, code} = await api.feedbackApi.queryUserOfProject(params)
      checkUserName({
        code,
        data,
        callback: ({userId}) => {
          const { userName, ...other } = params
          dispatch('setViewDataList', {
            ...other,
            userId,
          })
        },
      })
      const {items, total} = data
      commit(SET_VIEW_DATA_LIST_SEARCHING, false)
      commit(SET_VIEW_DATA_LIST, items)
      commit(SET_VIEW_DATA_LIST_PAGE_TOTAL, total)
    } catch (error) {
      commit(SET_VIEW_DATA_LIST_SEARCHING, false)
      commit(SET_VIEW_DATA_LIST, [])
      commit(SET_VIEW_DATA_LIST_PAGE_TOTAL, 0)
    }
  },
  initViewDataList ({dispatch}) {
    dispatch('setViewDataList')
  },
  async changeViewDataListPage ({commit, dispatch}, payload) {
    commit(SET_VIEW_DATA_LIST_PAGE_NUM, payload.currentPage)
    dispatch('setViewDataList')
  },
  changeViewDataListPageSize ({commit, dispatch}, payload) {
    commit(SET_VIEW_DATA_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeViewDataListPage', {currentPage: 1})
  },
  setViewDataListQuery ({commit, dispatch}, payload) {
    commit(SET_VIEW_DATA_LIST_QUERY, payload)
  },
  async queryChooseQuestionnaire ({commit, dispatch}, payload) {
    const data = await api.feedbackApi.queryQuestionnaireIdAndName()
    if (data.result && data.code === 200) {
      commit(SET_QUETSIONNAIREID_NAME_LIST, data.data)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
